import { Button } from '../../../../cdl/Button/Button';
import { Modal } from '../../../../cdl/Modal/Modal';
import { Text } from '../../../../cdl/Text/Text';
import { ButtonGroup } from '../../../../common/buttons/ButtonGroup';
import { Box } from '../../../../common/ui/Box';

export const SimpleConfirmPopup = ({
    isOpen,
    onDismiss,
    onSubmit,
    headline,
    description,
    buttonText,
    isSubmitting,
}) => {
    return (
        <Modal isOpen={isOpen} onDismiss={onDismiss} scrollable={false}>
            <Box padding={24} display="grid" rowGap={16}>
                <Text variant="title">{headline}</Text>

                <Text color="foreground.subtle">{description}</Text>

                <ButtonGroup justifyContent="end">
                    <Button emphasis="high" isLoading={isSubmitting} onClick={onSubmit}>
                        {buttonText}
                    </Button>
                </ButtonGroup>
            </Box>
        </Modal>
    );
};
